module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('section', [_c('carousel', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    attrs: {
      "navigationEnabled": true,
      "navigationNextLabel": '',
      "navigationPrevLabel": '',
      "perPage": 1,
      "paginationActiveColor": '#f58466',
      "paginationColor": '#999999',
      "navigationClickTargetSize": 5,
      "paginationPadding": 5,
      "paginationSize": 14
    }
  }, [_vm._l((_vm.props), function(slide, i) {
    return (_vm.props.length) ? [_c('slide', {
      staticClass: "column-slider"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "inside"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('h3', [_vm._v(_vm._s(slide.headline.value))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(slide.content.value)
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "button-custom prev",
      class: {
        disabled: i == 0
      },
      attrs: {
        "data-next": i
      },
      on: {
        "click": function($event) {
          return _vm.goToPrev(i)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "button-custom next",
      class: {
        disabled: i == _vm.props.length - 1
      },
      attrs: {
        "data-next": i
      },
      on: {
        "click": function($event) {
          return _vm.goToNext(i)
        }
      }
    })]), _vm._v(" "), (slide.vimeo_id) ? [(slide.vimeo_id.value != '') ? _c('div', {
      staticClass: "video-container"
    }, [_c('div', {
      staticClass: "embed-container"
    }, [_c('iframe', {
      attrs: {
        "src": 'https://player.vimeo.com/video/' + slide.vimeo_id.value + '?loop=1&title=0&byline=0&portrait=0&api=1',
        "width": "640",
        "height": "360",
        "frameborder": "0",
        "allow": "autoplay; fullscreen",
        "allowfullscreen": ""
      }
    })])]) : _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": slide.image.value[0].url,
        "alt": slide.headline.value
      }
    })])] : _vm._e()], 2)])])] : _vm._e()
  })], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5f03f9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider-video.vue
// module id = 1554
// module chunks = 0